export const BANDWIDTH_CATEGORIES = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'tasks-customers', label: 'Tasks & Customers' },
  { id: 'dates', label: 'Monthwise' },
  { id: 'users', label: 'Weekwise' },
] as const;

export type BandwidthCategoryId = (typeof BANDWIDTH_CATEGORIES)[number]['id'];
